import { useEffect } from 'react';
import ReactDOM from 'react-dom';
// --- external imports -----

/**
 * root Element (which game is mounted to) is initially has none display 
 * to mount game on it and starts it's initialization while splash screen is displayed.
 * After init, splash screen is hidden first then unmounted.
 * 
 * This is used to overcome black screen flash after splash screen
 * [Bug 2344](https://mirqah.kanbanize.com/ctrl_board/8/cards/2344/details/)
 */
function useAfterGameLoaded() {
	useEffect(() => {
		const rootElement = document.getElementById('root');
		const splashscreenElement = document.getElementById('splashscreen-root');

		rootElement.style.display = 'block';
		splashscreenElement.style.display = 'none';

		ReactDOM.unmountComponentAtNode(splashscreenElement);
	}, []);
};

export default useAfterGameLoaded;
